import { FiRefreshCw } from "react-icons/fi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useT } from "../../i18n";
import "./MobileHeaderRefreshButton.css";

export default function MobileHeaderRefreshButton() {
  const t = useT();
  const activeTab = useSelector((state) => state.tab.activeTab);
  const missionStatus = useSelector(
    (state) => state.drone.control.missionStatus
  );

  const handleRefreshClick = () => {
    if (activeTab === "Mission" && missionStatus) {
      toast.warn(t("common.mobileRefresh.missionRunning"), {
        toastId: "mobile-refresh-mission-running",
      });
      return;
    }

    window.location.reload();
  };

  return (
    <button
      type="button"
      className="mobile-header-refresh"
      onClick={handleRefreshClick}
      aria-label={t("common.mobileRefresh.label")}
      title={t("common.mobileRefresh.label")}
    >
      <FiRefreshCw aria-hidden="true" />
    </button>
  );
}
